import { useMemo } from 'react';
import { Option, useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
interface Params {
  disabled?: boolean;
  organizationId?: string;
}
const useGetPlanYearsQuery = ({ disabled, organizationId }: Params) => {
  const { data, isLoading, refetch, isError } = useQuery(
    [API_URL.METRICS_ACCOUNT_USAGE_PLAN_YEARS, disabled, organizationId],
    () => api.get(API_URL.METRICS_ACCOUNT_USAGE_PLAN_YEARS),
    {
      retry: 0,
      enabled: !disabled,
    }
  );
  const options = useMemo<Option[] | null>(() => {
    if (!data?.data) {
      return null;
    }
    return data?.data?.map((item) => ({
      key: item.plan_year_id,
      value: item.plan_year_name,
    }));
  }, [data]);
  return {
    isError,
    refetch,
    options,
    isLoading,
  };
};

export default useGetPlanYearsQuery;
